import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const ClientApi = createApi({
    reducerPath: "client",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['Client'],
    endpoints: (builder) => ({
        getAllClients: builder.query({
            query: ({ pageno, status, search, sort , role  , dropdown ,sortOrder , sortBy , limit}) => {
                let url = `${role}/clients?pageno=${pageno}`;
                if (status) {
                    url += `&status=${status}`;
                }
                if (search) {
                    url += `&search=${search}`;
                }
                if (sort) {
                    url += `&sort=${sort}`;
                }
                if (dropdown) {
                    url += `&dropdown=${dropdown}`;
                }
                if (sortOrder) {
                    url += `&sortOrder=${sortOrder}`;
                }   
                if (sortBy) {
                    url += `&sortBy=${sortBy}`;
                }
                if(limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET"
                }
            }
            , providesTags: ['Client'],
        }),
        addClient: builder.mutation({
            query: ({ data }) => ({
                url: `contractor/client`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Client'],
        }),
        updateClient: builder.mutation({
            query: ({ id, data }) => ({
                url: `contractor/client/${id}`,
                method: "PUT",
                body: data
            })
            , invalidatesTags: ['Client'],
        }),
        deleteClient: builder.mutation({
            query: ({ id }) => ({
                url: `contractor/client/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ['Client'],
        }),
        getSingleClient: builder.query({
            query: ({ search , role , type }) => {
                let url = `${role}/search/client`;
                if (search) {
                    url += `?search=${search}`;
                }
                if (type) {
                    url += `&type=${type}`
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ['Client'],
        }),
        AddBulkEmail: builder.mutation({
            query: ({ data }) => ({
                url: `contractor/email/client/bulk`,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Client'],
        }),
        getSinglClientById: builder.query({
            query: ({ id , role }) => ({
                url: `${role}/client/${id}`,
                method: "GET"
            }),
            providesTags: ['Client'],
        }),
        updateClientStatus: builder.mutation({
            query: ({ id }) => ({
                url: `contractor/client/status/${id}`,
                method: "PUT"
            }),
            invalidatesTags: ['Client'],
        }),
        getClientQuotesHistory: builder.query({
            query: ({ id , role }) => ({
                url: `${role}/client/${id}/quotes_history`,
                method: "GET"
            }),
            providesTags: ['Client'],
        }),
        getClientJobHistory: builder.query({
            query: ({ id, status , role }) => {
                let url = `${role}/client/${id}/job_history`;
                if (status) {
                    url += `?status=${status}`;
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ['Client'],
        }),
        getClientInvoiceHistory: builder.query({
            query: ({ id , role,status, partialOrUnpaid }) => {
                let url = `${role}/client/${id}/invoice_history`;
                if (status) {
                    url += `?status=${status}`;
                }
                if (partialOrUnpaid) {
                    url += `?partialOrUnpaid=${partialOrUnpaid}`;
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ['Client'],
        }),
    })
});


export const {
    useAddClientMutation,
    useGetAllClientsQuery,
    useUpdateClientMutation,
    useDeleteClientMutation,
    useGetSingleClientQuery,
    useAddBulkEmailMutation,
    useGetSinglClientByIdQuery,
    useUpdateClientStatusMutation,
    useGetClientQuotesHistoryQuery,
    useGetClientJobHistoryQuery,
    useGetClientInvoiceHistoryQuery
} = ClientApi;